import React from 'react';
import Modal from 'react-modal';
import { CanceledBy, stripHtmlTags } from './CommonFunctions';

export const handleOnRequestCloseWithViewMore = (onRequestClose, setFullView) => {
  onRequestClose();
  setFullView((prevState) => ({ ...prevState, viewMore: false }));
};

const CancelledMeetingModal = ({
  isOpen,
  onRequestClose,
  customStyles,
  fullView,
  setFullView,
  agendaDivHeight,
  extractTextFromHtml
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => handleOnRequestCloseWithViewMore(onRequestClose, setFullView)}
      style={customStyles}
      shouldCloseOnOverlayClick={false}
    >
      <div className="inner-cancel-meet-detail-modal">
        <div className="tb-modal-close-btn" onClick={onRequestClose}  data-testid="modal-close-btn"><span>X</span></div>
        <div className='view-modal-type-tag'><div className='view-model-typeofmeet-tag-inner'>Cancelled Meeting</div></div>
        <div className="UPM-view-modal-info-cont">
          <h3 style={{ fontSize: "21px", textTransform: "capitalize", marginBottom: "10px" }}>{fullView.data?.title}</h3>
          <div className="UPM-view-modal-row" >
            <div style={{ display: 'flex' }}>
              <div className="label-title2"> <p>Date</p> <span className='dateSpanColon'>:</span></div>
              <div className="label-value2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{fullView?.data?.date}</div>
            </div>
            <div style={{ display: 'flex' }}>
              <div className="label-title3"> <p style={{ paddingLeft: '45px' }}>Time</p> <span>:</span></div>
              <div className="label-value3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{fullView.data?.startTime}&nbsp;-&nbsp;{fullView.data?.endTime === "11:59 PM" ? "12:00 AM" : fullView.data?.endTime}</div>
            </div>
          </div>
          <div className="UPM-view-modal-row2">
            <div className="label-title">
              <p>Agenda</p>
              <span>:</span>
            </div>
            <div style={{ paddingLeft: "6%" }}>
              {
                !(stripHtmlTags(fullView?.data?.agenda ? fullView?.data?.agenda[0] : [] || '')?.length === 0 || fullView?.data?.agenda.length === 0) ? (
                  <div
                    id="agenda_div"
                    dangerouslySetInnerHTML={{ __html: fullView?.data?.agenda }}
                    className={fullView.viewMore === false ? "addEllipses" : "removeEllipses"}
                    style={{ width: '100%', fontSize: '13px' }}
                  />
                ) : (
                  <div style={{ fontSize: '13px', color: "black" }}>Not Available</div>
                )
              }
              {agendaDivHeight &&
                <div className="read-more">
                  <button
                    style={{ border: "none", backgroundColor: "transparent", textDecoration: "underline", color: "#00ADEE" }}
                    onClick={() => setFullView((prevState) => ({ ...prevState, viewMore: !prevState.viewMore }))}
                    data-testid="viewMore"
                  >
                    {fullView.viewMore ? " View less" : "View more "}
                  </button>
                </div>
              }
            </div>
          </div>
          <CanceledBy setFullView={setFullView} fullView={fullView} />
        </div>
      </div>
    </Modal>
  );
};

export default CancelledMeetingModal;
